ixModuleRouting("impactx.address", {
    "/addresslist": {
        template: "<ixa-address-list></ixa-address-list>",
        templateUrl: "modules/address/templates/addresslist.html",
        controller: "AddressListController",
        controllerAs: "addressListController",
        process: "EditCompanyAddress",
        workspace: "admin",
    },
    "/useraddresslist": {
        template: "<ixa-user-address-list></ixa-user-address-list>",
        templateUrl: "modules/address/templates/user-addresslist.html",
        controller: "UserAddressListController",
        controllerAs: "userAddressListController",
        process: "EditProfile",
        workspace: "shop",
    },
    "/addressdetail/:id": {
        template: "<ixa-address-detail></ixa-address-detail>",
        templateUrl: "modules/address/templates/address-full.html",
        controller: "AddressDetailCtrl",
        controllerAs: "ctrl",
        process: "EditCompanyAddress",
        workspace: "admin",
    },
    "/useraddressdetail/:id/:optId?": {
        template: "<ixa-address-user></ixa-address-user>",
        templateUrl: "modules/address/templates/address-user.html",
        controller: "UserAddressDetailCtrl",
        controllerAs: "ctrl",
        process: "EditProfile",
        workspace: "shop",
    },
});
